// extracted by mini-css-extract-plugin
module.exports = {"Bubble":"Bubble_Bubble__YYpJx","Bubble_slide-top__3GUGp":"Bubble_Bubble_slide-top__3GUGp__QyvaT","CloseButton":"Bubble_CloseButton__19M4A","slide-top":"Bubble_slide-top__3GHMX"};